import * as Q from '../graphql/queries/multibss/secret-circle.query';
import { ApiResponse, query } from './api';
import * as T from './secret-circle.types';
import { SuccessResponse } from './television.types';

interface SecretCircleApiInterface {
  getSecretCircle(billingCustomerId: string): ApiResponse<T.SecretCircleStatus>;
  updateSecretCircle(
    billingCustomerId: string,
    secretCircleStatus?: T.SecretCircleStatus
  ): ApiResponse<SuccessResponse>;
}

export const SecretCircleApi: SecretCircleApiInterface = {
  getSecretCircle(billingCustomerId: string) {
    return query<{ getSecretCircle: T.SecretCircleStatus }>({
      query: Q.getSecretCircleQuery,
      variables: { billingCustomerId },
      name: 'getSecretCircle',
    }).then(({ getSecretCircle }) => ({ data: getSecretCircle }));
  },
  updateSecretCircle(billingCustomerId: string, secretCircleStatus: T.SecretCircleStatus) {
    return query<{ updateSecretCircle: SuccessResponse }>({
      query: Q.updateSecretCircleQuery,
      variables: { billingCustomerId, secretCircleStatus },
      name: 'updateSecretCircle',
    }).then(({ updateSecretCircle }) => ({ data: updateSecretCircle }));
  },
};
